<template>
  <div class="about">

    <section id="portada" class="animacion">
        <div class="contedor-portada">
          <div class="portada-contenido animacion">
          <h1>{{nom_sub_sec_es}}</h1>
          <ul>
            <li><router-link tag="a" to="/">Inicio</router-link></li>
            <li class="sin-division">{{nom_sub_sec_es}}</li>
          </ul>
          </div>
          <img
            class="imagen-cover"
            v-bind:src='imgPreUrl+ url_1st_image +"x640.jpg"'
            v-bind:alt='type_1st_image'>
        </div>
      </section>

    <section id="servicios" class="secciones seccion-blanca formulario">        
      <div class="container">
        <h1>{{internal_name_es}}</h1>
        <span v-html="desc_sub_section_es"></span>
        <form data-toggle="validator" role="form" action="" @submit.prevent="registrar_consulta">

          <div class="col-sm-6">

            <div class="form-group">
              <span class="ico-form ico-form-nombre"><input type="text" class="form-control ico-form-space" v-model="nombre_completo" placeholder="Nombre Completo *" required pattern=".*[^ ].*" title="Ingrese su nombre completo." maxlength="150"></span>
            </div>

            <div class="form-group">
              <span class="ico-form ico-form-email"><input type="email" class="form-control ico-form-space" v-model="correo_electronico" placeholder="Correo electrónico *" required title="Ingrese el correo electrónico del contacto." maxlength="200"></span>
            </div>

            <div class="form-group">
              <select class="form-control no-border-country" v-model="codigo_pais" @change="get_selected_text" required>
                <option value="">Seleccione aquí el país *</option>
                <option value="+7">Abjasia</option>
                <option value="+93">Afganistán</option>
                <option value="+355">Albania</option>
                <option value="+49">Alemania</option>
                <option value="+376">Andorra</option>
                <option value="+244">Angola</option>
                <option value="+1264">Anguilla</option>
                <option value="+1268">Antigua y Barbuda</option>
                <option value="+599">Antillas Holandesas</option>
                <option value="+672">Antártida</option>
                <option value="+966">Arabia Saudita</option>
                <option value="+213">Argelia</option>
                <option value="+54">Argentina</option>
                <option value="+374">Armenia</option>
                <option value="+297">Aruba</option>
                <option value="+61">Australia</option>
                <option value="+43">Austria</option>
                <option value="+994">Azerbaiyán</option>
                <option value="+1242">Bahamas</option>
                <option value="+973">Bahrein</option>
                <option value="+880">Bangladesh</option>
                <option value="+1246">Barbados</option>
                <option value="+501">Belice</option>
                <option value="+229">Benin</option>
                <option value="+1441">Bermudas</option>
                <option value="+375">Bielorrusia</option>
                <option value="+591">Bolivia</option>
                <option value="+599">Bonaire</option>
                <option value="+387">Bosnia-Herzegovina</option>
                <option value="+267">Botswana</option>
                <option value="+55">Brasil</option>
                <option value="+673">Brunei Darussalam</option>
                <option value="+359">Bulgaria</option>
                <option value="+226">Burkina Faso</option>
                <option value="+257">Burundi</option>
                <option value="+975">Bután</option>
                <option value="+32">Bélgica</option>
                <option value="+238">Cabo Verde</option>
                <option value="+855">Camboya</option>
                <option value="+237">Camerún</option>
                <option value="+1">Canadá</option>
                <option value="+235">Chad</option>
                <option value="+56">Chile</option>
                <option value="+86">China</option>
                <option value="+357">Chipre</option>
                <option value="+57">Colombia</option>
                <option value="+269">Comores</option>
                <option value="+242">Congo</option>
                <option value="+243">Congo RD</option>
                <option value="+850">Corea del Norte</option>
                <option value="+82">Corea del Sur</option>
                <option value="+506">Costa Rica</option>
                <option value="+225">Costa de Marfil</option>
                <option value="+385">Croacia</option>
                <option value="+53">Cuba</option>
                <option value="+599">Curacao</option>
                <option value="+45">Dinamarca</option>
                <option value="+1767">Dominica</option>
                <option value="+1809">República Dominicana</option>
                <option value="+593">Ecuador</option>
                <option value="+20">Egipto</option>
                <option value="+503">El Salvador</option>
                <option value="+971">Emiratos Árabes Unidos</option>
                <option value="+291">Eritrea</option>
                <option value="+421">Eslovaquia</option>
                <option value="+386">Eslovenia</option>
                <option value="+34">España</option>
                <option value="+1">Estados Unidos</option>
                <option value="+372">Estonia</option>
                <option value="+251">Etiopía</option>
                <option value="+679">Fiji</option>
                <option value="+63">Filipinas</option>
                <option value="+358">Finlandia</option>
                <option value="+33">Francia</option>
                <option value="+241">Gabón</option>
                <option value="+220">Gambia</option>
                <option value="+995">Georgia</option>
                <option value="+233">Ghana</option>
                <option value="+350">Gibraltar</option>
                <option value="+1473">Granada</option>
                <option value="+30">Grecia</option>
                <option value="+299">Groenlandia</option>
                <option value="+590">Guadalupe</option>
                <option value="+1671">Guam</option>
                <option value="+502">Guatemala</option>
                <option value="+594">Guayana francés</option>
                <option value="+44">Guernsey</option>
                <option value="+245">Guinea Bissau</option>
                <option value="+240">Guinea Ecuatorial</option>
                <option value="+592">Guyana</option>
                <option value="+509">Haiti</option>
                <option value="+504">Honduras</option>
                <option value="+852">Hong Kong</option>
                <option value="+36">Hungría</option>
                <option value="+91">India</option>
                <option value="+62">Indonesia</option>
                <option value="+98">Iran</option>
                <option value="+964">Iraq</option>
                <option value="+353">Irlanda</option>
                <option value="+61">Isla de Navidad</option>
                <option value="+672">Isla Norfolk</option>
                <option value="+44">Isla de Man</option>
                <option value="+358">Isla de Åland</option>
                <option value="+699">Isla periféricas menores de Estados Unidos</option>
                <option value="+354">Islandia</option>
                <option value="+1345">Islas Caimán</option>
                <option value="+61">Islas Cocos</option>
                <option value="+682">Islas Cook</option>
                <option value="+298">Islas Feroe</option>
                <option value="+500">Islas Malvinas</option>
                <option value="+692">Islas Marshall</option>
                <option value="+872">Islas Pitcairn</option>
                <option value="+677">Islas Salomón</option>
                <option value="+1649">Islas Turcas y Caicos</option>
                <option value="+128">Islas Vírgenes Británicas</option>
                <option value="+134">Islas Vírgenes de EE.UU.</option>
                <option value="+972">Israel</option>
                <option value="+39">Italia</option>
                <option value="+187">Jamaica</option>
                <option value="+81">Japón</option>
                <option value="+44">Jersey</option>
                <option value="+962">Jordania</option>
                <option value="+7">Kazajstán</option>
                <option value="+254">Kenia</option>
                <option value="+996">Kirguistán</option>
                <option value="+686">Kiribati</option>
                <option value="+377">Kosovo</option>
                <option value="+965">Kuwait</option>
                <option value="+856">Laos</option>
                <option value="+266">Lesotho</option>
                <option value="+371">Letonia</option>
                <option value="+231">Liberia</option>
                <option value="+218">Libia</option>
                <option value="+423">Liechtenstein</option>
                <option value="+370">Lituania</option>
                <option value="+352">Luxemburgo</option>
                <option value="+961">Líbano</option>
                <option value="+853">Macao</option>
                <option value="+389">Macedonia</option>
                <option value="+261">Madagascar</option>
                <option value="+60">Malasia</option>
                <option value="+265">Malawi</option>
                <option value="+960">Maldivas</option>
                <option value="+356">Malta</option>
                <option value="+223">Malí</option>
                <option value="+1670">Marianas del Norte</option>
                <option value="+212">Marruecos</option>
                <option value="+596">Martinica</option>
                <option value="+230">Mauricio</option>
                <option value="+222">Mauritania</option>
                <option value="+262">Mayotte</option>
                <option value="+691">Micronesia</option>
                <option value="+373">Moldavia</option>
                <option value="+976">Mongolia</option>
                <option value="+382">Montenegro</option>
                <option value="+1664">Montserrat</option>
                <option value="+258">Mozambique</option>
                <option value="+95">Myanmar</option>
                <option value="+52">México</option>
                <option value="+377">Mónaco</option>
                <option value="+264">Namibia</option>
                <option value="+674">Nauru</option>
                <option value="+977">Nepal</option>
                <option value="+505">Nicaragua</option>
                <option value="+234">Nigeria</option>
                <option value="+683">Niue</option>
                <option value="+47">Noruega</option>
                <option value="+687">Nueva Caledonia</option>
                <option value="+64">Nueva Zelanda</option>
                <option value="+227">Níger</option>
                <option value="+968">Omán</option>
                <option value="+92">Pakistán</option>
                <option value="+680">Palau</option>
                <option value="+970">Palestina</option>
                <option value="+507">Panamá</option>
                <option value="+675">Papúa Nueva Guinea</option>
                <option value="+595">Paraguay</option>
                <option value="+31">Países Bajos, Holanda</option>
                <option value="+51">Perú</option>
                <option value="+689">Polinesia Francesa</option>
                <option value="+48">Polonia</option>
                <option value="+351">Portugal</option>
                <option value="+1787">Puerto Rico</option>
                <option value="+974">Qatar</option>
                <option value="+44">Reino Unido</option>
                <option value="+236">República Centroafricana</option>
                <option value="+420">República Checa</option>
                <option value="+224">República Guinea</option>
                <option value="+262">Reunión</option>
                <option value="+250">Ruanda</option>
                <option value="+40">Rumanía</option>
                <option value="+7">Rusia</option>
                <option value="+685">Samoa</option>
                <option value="+1684">Samoa Americana</option>
                <option value="+1869">San Cristóbal y Nevis</option>
                <option value="+378">San Marino</option>
                <option value="+590">San Martin</option>
                <option value="+508">San Pedro y Miquelón</option>
                <option value="+1784">San Vincente y Granadinas</option>
                <option value="+290">Santa Helena</option>
                <option value="+1758">Santa Lucía</option>
                <option value="+239">Santo Tomé y Príncipe</option>
                <option value="+221">Senegal</option>
                <option value="+381">Serbia</option>
                <option value="+248">Seychelles</option>
                <option value="+232">Sierra Leona</option>
                <option value="+65">Singapur</option>
                <option value="+963">Siria</option>
                <option value="+252">Somalía</option>
                <option value="+94">Sri Lanka</option>
                <option value="+27">Sudáfrica</option>
                <option value="+249">Sudán</option>
                <option value="+211">Sudán del Sur</option>
                <option value="+46">Suecia</option>
                <option value="+41">Suiza</option>
                <option value="+597">Surinam</option>
                <option value="+47">Svalbard y Jan Mayen</option>
                <option value="+268">Swazilandia</option>
                <option value="+212">Sáhara Occidental</option>
                <option value="+992">Tadjikistan</option>
                <option value="+66">Tailandia</option>
                <option value="+886">Taiwán</option>
                <option value="+255">Tanzania</option>
                <option value="+246">Territorio Británico del Océano Índico</option>
                <option value="+262">Territorios Franceses del Sur</option>
                <option value="+670">Timor del Este</option>
                <option value="+228">Togo</option>
                <option value="+690">Tokelau</option>
                <option value="+676">Tonga</option>
                <option value="+1868">Trinidad y Tobago</option>
                <option value="+993">Turkmenistán</option>
                <option value="+90">Turquía</option>
                <option value="+688">Tuvalu</option>
                <option value="+216">Túnez</option>
                <option value="+380">Ucrania</option>
                <option value="+256">Uganda</option>
                <option value="+598">Uruguay</option>
                <option value="+998">Uzbekistán</option>
                <option value="+678">Vanuatu</option>
                <option value="+379">Vaticano</option>
                <option value="+58">Venezuela</option>
                <option value="+84">Vietnam</option>
                <option value="+681">Wallis y Futuna</option>
                <option value="+967">Yemen</option>
                <option value="+253">Yibuti</option>
                <option value="+260">Zambia</option>
                <option value="+263">Zimbábue</option>
              </select>
            </div>

            <div class="form-group" v-if="pais != 'Perú'">
              <span class="ico-form ico-form-nombre"><input type="text" class="form-control ico-form-space" v-model="ciudad" placeholder="Provincia o ciudad *" required pattern=".*[^ ].*" title="Ingrese la provincia o ciudad."></span>
            </div>

            <template v-if="pais == 'Perú'">
              <div class="form-group">
                <select v-model="cboDepartamento" class="form-control no-border-country" :plain="true" @change="(event) => callProvincias(cboDepartamento)">
                  <option disabled value="">Seleccione aquí el departamento</option>
                  <option v-for="depa in depas_array" :key="depa.id_departament" :value="depa.id_departament">{{depa.desc_departament}}</option>
                </select>
              </div>

              <div class="form-group">
                <select v-model="cboProvincia" class="form-control no-border-country" :disabled="isdisabled" :required="isdisabled" @change="(event) => callDistritos(cboProvincia)">
                  <option disabled value="">Seleccione aquí la provincia</option>
                  <option v-for="provincia in province_array" :key="provincia.id_province" :value="provincia.id_province">{{provincia.desc_province}}</option>
                </select>
              </div>

              <div class="form-group">
                <select v-model="cboDistrito" class="form-control no-border-country" :disabled="isdisabled_distrito" :required="isdisabled_distrito" @change="(event) => enableDireccion()">
                  <option disabled value="">Seleccione aquí el distrito</option>
                  <option v-for="distrito in distrito_array" :key="distrito.id_district" :value="distrito.id_district">{{distrito.desc_district}}</option>
                </select>
              </div>
            </template>
            <template v-else>
              <div class="form-group col-lg-6 col-sm-12 not-padding-left-fields">
                <input type="text" class="form-control ico-form-space" :value="codigo_pais == '' ? 'Código del país elegido' : pais + ' (' + codigo_pais + ')'" id="codigoTelefonoNacional" disabled>
              </div>

              <div class="form-group  col-lg-6 col-sm-12 not-padding-right-fields">
                <span class="ico-form ico-form-telefono"><input type="text" v-model="telefono" class="form-control ico-form-space" placeholder="Teléfono o celular *" pattern="[0-9()+][0-9() -]+" title="Ingrese un teléfono válido" id="numeroTelefonoNacional" maxlength="20" required></span>
              </div>
            </template>
          </div>

          <div class="col-sm-6">
            
            <template v-if="pais == 'Perú'">
              <div class="form-group col-sm-6 not-padding-left-fields-peru">
                <input type="text" class="form-control ico-form-space" :value="codigo_pais == '' ? 'Código del país elegido' : pais + ' (' + codigo_pais + ')'" id="codigoTelefonoNacional" disabled>
              </div>

              <div class="form-group col-sm-6 not-padding-right-fields-peru">
                <span class="ico-form ico-form-telefono"><input type="text" v-model="telefono" class="form-control ico-form-space" placeholder="Teléfono o celular *" pattern="[0-9()+][0-9() -]+" title="Ingrese un teléfono válido" id="numeroTelefonoNacional" maxlength="20" required></span>
              </div>
            </template>

            <div class="form-group">
              <span class="ico-form ico-form-nombre"><input type="text" class="form-control ico-form-space" v-model="asunto" placeholder="Asunto *" required pattern=".*[^ ].*" title="Ingrese el asunto de la consulta." maxlength="200"></span>
            </div>

            <div class="form-group">
              <textarea class="form-control" :style="pais != 'Perú' ? 'height: 248px;' : 'height: 248px;'" rows="8" v-model="comentario" placeholder="Escríbanos su consulta. Trataremos de responder tu pedido y/o consulta en el transcurso de nuestro horario comprendido de Lunes a viernes 10:00 a.m. a 7:00 p.m. Sábados 9:30 a.m. a 01:30 p.m. . Gracias por tu preferencia y atención. *" maxlength="500" required></textarea>
            </div>

          </div>
          
          <div class="col-xs-12 text-center">
            <div class="mensaje-obligatorio">* Los campos marcados con asterisco son obligatorios.</div>
            <p>
              <input type="checkbox" id="checkbox" class="contact-inline" v-model="checked"> 
              <small><strong>
                He leido y estoy de acuerdo con las <a @click="show_politicas_privacidad" style="color: #d02031; cursor: pointer;">políticas de privacidad</a> de Armaq.
              </strong></small>
            </p>

            <span style="color: rgb(130,132,138); font-size: 12px;" v-if="show_politicas">En cumplimiento con lo señalado en el artículo 6 de la Ley de Protección de Datos Personales, ponemos en su conocimiento que los datos personales brindados a ARMAQ S.A., solo serán empleados para el envío de ofertas y novedades para nuestros Clientes. Los mismos serán resguardados únicamente para tal fin por ARMAQ S.A., en estricto seguimiento del artículos 9 y 11 de la norma anteriormente citada.</span>
            
          </div>

          <template v-if="mensaje !=''">
            <div class="col-xs-12 text-center">
              <div :class="[(mensaje === '') ? 'd-none' : 'alert alert-success']" role="alert"><button type="button" class="close" data-dismiss="alert" @click="ocultar()">&times;</button><strong>{{ mensaje }}</strong></div>
            </div>
          </template>
          <template v-if="mensaje_error != ''">
            <div class="col-xs-12 text-center">
              <div :class="[(mensaje_error === '') ? 'd-none' : 'alert alert-danger']" role="alert"><button type="button" class="close" data-dismiss="alert" @click="ocultar()">&times;</button><strong>{{ mensaje_error }}</strong></div>
            </div>
          </template>
          <template v-if="loading_form != false">
            <div class="col-xs-12 text-center">
            <div class="progress">
              <div class="progress-bar progress-bar-striped active" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" style="width: 100%"></div>
            </div>
            </div>
          </template>
          &nbsp;

          <div class="col-xs-12 text-center  mt-2">
            <button type="submit" class="btn btn-lg btn-primary" :disabled="!checked">Enviar Consulta</button>
          </div>

        </form>
      </div>
    </section>

    <TwoModules></TwoModules>
    <NewModules></NewModules>

  </div>

</template>

<style>

.contact-inline{
      height: 10px !important;
}
.no-border-country {
  border-radius: 2px !important;
}

.avatar {
  border-radius: 10px;
}
.row-height2 {
  background-color: #e5e5ea;
  border-radius: 15px 15px 15px 15px;
}

.not-padding-left{padding-left: 0 !important; padding-right: 12px !important;}
.not-padding-right{padding-right: 0 !important; padding-left: 12px !important;}
.posicion-relativa{position: relative;}
.btn-3d-celeste{
	color: rgb(43,172,234);
  border-color: rgb(43,172,234);
  background-color: transparent;
}
.btn-3d-celeste:hover,.btn-3d-celeste:focus,.btn-3d-celeste:active{color: rgba(43,172,234,.7);}
.btn-3d {
    position: relative;
    display: inline-block;
    top: 0;
    margin-bottom: 0;
    font-weight: 700;
    font-family: 'Montserrat', sans-serif;
    text-transform: uppercase;
    border-style: solid;
    border-top-width: 1px;
    border-right-width: 1px;
    border-bottom-width: 6px;
    border-left-width: 1px;
    border-radius: 8px;
    transition: all .15s;
}
.btn-3d:hover{
	top: 4px;
	margin-bottom: 3px;
	border-bottom-width: 3px;
}
.btn-3d:active{
	top: 6px;
	margin-bottom: 5px;
	border-bottom-width: 1px;
}

@media(min-width: 0px) {
	.btn-3d-md{padding: 12px;font-size: 14px;}
	.btn-3d-lg{padding: 10px 15px;font-size: 14px;}
  .not-padding-left-fields{padding-left: 0px !important; padding-right: 0px !important;}
  .not-padding-right-fields{padding-right: 0px !important; padding-left: 0px !important;}

  .not-padding-left-fields-peru{padding-left: 0 !important; padding-right: 0px !important;}
  .not-padding-right-fields-peru{padding-right: 0 !important; padding-left: 0px !important;}
}
@media(min-width: 576px) {
	.btn-3d-md{padding: 12px;font-size: 14px;}
	.btn-3d-lg{padding: 10px 15px;font-size: 14px;}
  .not-padding-left-fields{padding-left: 0px !important; padding-right: 0px !important;}
  .not-padding-right-fields{padding-right: 0px !important; padding-left: 0px !important;}

  .not-padding-left-fields-peru{padding-left: 0 !important; padding-right: 10px !important;}
  .not-padding-right-fields-peru{padding-right: 0 !important; padding-left: 0px !important;}
}
@media(min-width: 768px) {
	.btn-3d-md{padding: 12px;font-size: 14px;}
	.btn-3d-lg{padding: 10px 15px;font-size: 14px;}
  .not-padding-left-fields{padding-left: 0px !important; padding-right: 0px !important;}
  .not-padding-right-fields{padding-right: 0px !important; padding-left: 0px !important;}

  .not-padding-left-fields-peru{padding-left: 0 !important; padding-right: 12px !important;}
  .not-padding-right-fields-peru{padding-right: 0 !important; padding-left: 12px !important;}
}
@media(min-width: 992px) {
	.btn-3d-md{padding: 10px 15px;font-size: 14px;}
	.btn-3d-lg{padding: 15px 20px;font-size: 15px;}
  .not-padding-left-fields{padding-left: 0 !important; padding-right: 12px !important;}
  .not-padding-right-fields{padding-right: 0 !important; padding-left: 12px !important;}
}
@media(min-width: 1200px) {
	.btn-3d-md{padding: 15px;font-size: 16px;}
	.btn-3d-lg{padding: 15px 25px;font-size: 16px;}
  .not-padding-left-fields{padding-left: 0 !important; padding-right: 12px !important;}
  .not-padding-right-fields{padding-right: 0 !important; padding-left: 12px !important;}
}

</style>

<script>
import TwoModules from "@/components/products/TwoModules.vue";
import NewModules from "@/components/products/NewModule.vue";
import axios from "axios";
import {config_settings} from '../config.js';
import _ from "lodash";
import { errorToaster } from '../components/shared/service/ErrorHandler';

//HTTP ERROR STATUS
  const NOT_FOUND = 404;
  const BAD_REQUEST = 400;
  const UNAUTHORIZED = 401;
  const INTERNAL_SERVER_ERROR = 500;

  axios.interceptors.response.use(function (response) { return response; }, 
  function (error) {
    
    if(error.message === 'Network Error'){
      toastr.error("No se puede conectar con el servidor. Verifique su conexión a internet",
                       "ERROR",
                       {"iconClass": 'customer-danger'});
    }
    else if(error.response.status === UNAUTHORIZED){
      if(error.response.data.message === "Access is denied"){
         toastr.error("Usted no tiene los provilegios para acceder a esta sección",
                       "ERROR",
                       {"iconClass": 'customer-danger'});
      }
      else {
        return Promise.reject(error);
      }
    }
    else {
      return Promise.reject(error);
    }
});

export default {
  components: {
    TwoModules,
    NewModules
  },
  data() {
    return {
      page_title: "",
      page_description: "",
      page_keywords: "",

    imgPreUrl : config_settings.PHOTO_SERVER_URL+'/',
    cod_sub_sec: 13,
    nom_sub_sec_es: '',
    nom_sub_sec_en: '',
    internal_name_es: '',
    internal_name_en: '',
    desc_sub_section_es: '',
    desc_sub_section_en: '',
    section: '',
    url_1st_image: 'products/empty-img',
    url_2nd_image: 'products/empty-img',
    url_3rd_image: 'products/empty-img',
    url_4th_image: 'products/empty-img',
    url_5th_image: 'products/empty-img',
    type_1st_image: 'image',
    type_2nd_image: 'image',
    type_3rd_image: 'image',
    type_4th_image: 'image',
    type_5th_image: 'image',
    text1_es: '',
    text1_en: '',
    text2_es: '',
    text2_en: '',
    text3_es: '',
    text3_en: '',
    orientation: '',
    url_es: '',
    url_en: '',
    order_sub_section: '',
    id_position_menu: '',
    url_video: '',
    type: '',

    checked: false,
    show_politicas: false,

    nombre_completo: '',
    correo_electronico: '',
    codigo_pais: '',
    pais: '',
    ciudad: '',
    telefono: '',
    asunto: '',
    comentario: '',
    mensaje: '',
    mensaje_error: '',
    loading_form: false,
    max_caracters: 0,

    cboDepartamento: '',
    cboProvincia: '',
    cboDistrito: '',
    txtDireccion: '',
    depas_array: [],
    province_array: [],
    distrito_array: [],
    isdisabled: true,
    isdisabled_distrito: true,
    isdisabled_direccion: true,

    coordinates: {
      0: {
        full_name: 'Armaq San Isidro',
        lat: '-12.099830',
        lng: '-77.019745'
      },
      1: {
        full_name: 'Armaq Jockey Plaza',
        lat: '-12.086355',
        lng: '-76.977085'
      },
      2: {
        full_name: 'Armaq Plaza Norte',
        lat: '-12.006168',
        lng: '-77.058908'
      },
      3: {
        full_name: 'Armaq Piura',
        lat: '-5.192881',
        lng: '-80.639651'
      }
    },

    options: {
           disableDefaultUI: true,
           scrollwheel: false,
           styles:  [
          {
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#1d2c4d"
              }
            ]
          },
          {
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#8ec3b9"
              }
            ]
          },
          {
            "elementType": "labels.text.stroke",
            "stylers": [
              {
                "color": "#1a3646"
              }
            ]
          },
          {
            "featureType": "administrative.country",
            "elementType": "geometry.stroke",
            "stylers": [
              {
                "color": "#4b6878"
              }
            ]
          },
          {
            "featureType": "administrative.land_parcel",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#64779e"
              }
            ]
          },
          {
            "featureType": "administrative.province",
            "elementType": "geometry.stroke",
            "stylers": [
              {
                "color": "#4b6878"
              }
            ]
          },
          {
            "featureType": "landscape.man_made",
            "elementType": "geometry.stroke",
            "stylers": [
              {
                "color": "#334e87"
              }
            ]
          },
          {
            "featureType": "landscape.natural",
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#023e58"
              }
            ]
          },
          {
            "featureType": "poi",
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#283d6a"
              }
            ]
          },
          {
            "featureType": "poi",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#6f9ba5"
              }
            ]
          },
          {
            "featureType": "poi",
            "elementType": "labels.text.stroke",
            "stylers": [
              {
                "color": "#1d2c4d"
              }
            ]
          },
          {
            "featureType": "poi.business",
            "stylers": [
              {
                "visibility": "off"
              }
            ]
          },
          {
            "featureType": "poi.park",
            "elementType": "geometry.fill",
            "stylers": [
              {
                "color": "#023e58"
              }
            ]
          },
          {
            "featureType": "poi.park",
            "elementType": "labels.text",
            "stylers": [
              {
                "visibility": "off"
              }
            ]
          },
          {
            "featureType": "poi.park",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#3C7680"
              }
            ]
          },
          {
            "featureType": "road",
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#304a7d"
              }
            ]
          },
          {
            "featureType": "road",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#98a5be"
              }
            ]
          },
          {
            "featureType": "road",
            "elementType": "labels.text.stroke",
            "stylers": [
              {
                "color": "#1d2c4d"
              }
            ]
          },
          {
            "featureType": "road.arterial",
            "elementType": "labels",
            "stylers": [
              {
                "visibility": "off"
              }
            ]
          },
          {
            "featureType": "road.highway",
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#2c6675"
              }
            ]
          },
          {
            "featureType": "road.highway",
            "elementType": "geometry.stroke",
            "stylers": [
              {
                "color": "#255763"
              }
            ]
          },
          {
            "featureType": "road.highway",
            "elementType": "labels",
            "stylers": [
              {
                "visibility": "off"
              }
            ]
          },
          {
            "featureType": "road.highway",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#b0d5ce"
              }
            ]
          },
          {
            "featureType": "road.highway",
            "elementType": "labels.text.stroke",
            "stylers": [
              {
                "color": "#023e58"
              }
            ]
          },
          {
            "featureType": "road.local",
            "stylers": [
              {
                "visibility": "off"
              }
            ]
          },
          {
            "featureType": "transit",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#98a5be"
              }
            ]
          },
          {
            "featureType": "transit",
            "elementType": "labels.text.stroke",
            "stylers": [
              {
                "color": "#1d2c4d"
              }
            ]
          },
          {
            "featureType": "transit.line",
            "elementType": "geometry.fill",
            "stylers": [
              {
                "color": "#283d6a"
              }
            ]
          },
          {
            "featureType": "transit.station",
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#3a4762"
              }
            ]
          },
          {
            "featureType": "water",
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#0e1626"
              }
            ]
          },
          {
            "featureType": "water",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#4e6d70"
              }
            ]
          }
        ]
    }
    
  }
  },

  metaInfo() {

        return {
             title:  this.page_title ? this.page_title : "",
             meta: [
              { name: 'description', content: this.page_description ? this.page_description : "" },
              { name: 'keywords', content: this.page_keywords ? this.page_keywords : "" },
              { name: 'robots', content: "index" }
            ]
        }
  },
  
  methods: {
    show_politicas_privacidad() {
      if(this.show_politicas) { this.show_politicas = false }
      else { this.show_politicas = true }
    },

    get_selected_text(e) {
        this.pais = e.target.options[e.target.options.selectedIndex].text;

        this.ciudad = ""
        this.cboDepartamento = ""
        this.cboProvincia = ""
        this.cboDistrito = ""
    },

    callDepartamentos () {
      axios({
        method: 'get',
        url: config_settings.RESOURCE_SERVER_URL+'/GET/locations/departments',
      })
      .then(response => {
        this.depas_array = response.data
      })
      .catch(error => {
        console.log(error); 
      })
    },

    callProvincias (cboDepartamento) {
      axios({
        method: 'get',
        url: config_settings.RESOURCE_SERVER_URL+'/GET/locations/departaments/'+cboDepartamento+'/provinces',
      })
      .then(response => {
        this.province_array = response.data
        this.cboProvincia = ""
        this.cboDistrito = ""
        this.isdisabled = false
        this.isdisabled_distrito = true
        this.txtDireccion = ""
        this.isdisabled_direccion = true
      })
      .catch(error => {
         console.log(error);
      })
    },

    callDistritos (cboProvincia) {
      axios({
        method: 'get',
        url: config_settings.RESOURCE_SERVER_URL+'/GET/locations/departments/provinces/'+cboProvincia+'/districts',
      })
      .then(response => {
        this.distrito_array = response.data
        this.cboDistrito = ""
        this.isdisabled_distrito = false
      })
      .catch(error => {
        console.log(error);  
      })
    },

    enableDireccion(){
      this.isdisabled_direccion = false;
    },

    registrar_consulta() {

        var distrito_json = ""
        if(this.cboDistrito != "") {
          distrito_json = { "id_district" : this.cboDistrito }
        }
        else {
          distrito_json = { "id_district" : null }
        }

        this.loading_form = true
        
        var json_data = {
          "complete_name" : this.nombre_completo,
          "email" : this.correo_electronico,
          "phone" : "(" + this.codigo_pais + ") " + this.telefono,
          "country" : this.pais,
          "city" : this.ciudad,
          "id_district" : distrito_json,
          "subject" : this.asunto,
          "commentary" : this.comentario
        }

        console.log(JSON.stringify(json_data))
        
        axios({
          method: 'post',
          url: config_settings.RESOURCE_SERVER_URL+'/POST/consulting',
          data: json_data,
        })
        .then(response => {
          this.mensaje = "¡Su consulta ha sido enviada exitosamente!"
          this.mensaje_error = ""
          this.reset();
          this.loading_form = false
        })
        .catch(error => {
          this.mensaje = ""
          this.mensaje_error = "Hubo un error al momento de enviar el mensaje. Inténtelo nuevamente."
          this.reset();
          this.loading_form = false
        })
    },

    ocultar() {
      this.mensaje = ""
      this.mensaje_error = ""
    },

    reset() {
      this.nombre_completo = ''
      this.correo_electronico = ''
      this.codigo_pais = ''
      this.pais = ''
      this.ciudad = ''
      this.telefono = ''
      this.asunto = ''
      this.comentario = ''

      this.cboDepartamento = ""
      this.cboProvincia = ""
      this.cboDistrito = ""

      this.checked = false
      this.show_politicas = false
    },

    obtener_sub_section_data(){
      axios.get(config_settings.RESOURCE_SERVER_URL+ '/GET/sub_sections/'+ this.cod_sub_sec)
           .then(response => {
              
              this.nom_sub_sec_es = response.data.nom_sub_sec_es
              this.nom_sub_sec_en = response.data.nom_sub_sec_en
              this.internal_name_es = response.data.internal_name_es
              this.internal_name_en  = response.data.internal_name_en  
              this.desc_sub_section_es = response.data.desc_sub_section_es  
              this.desc_sub_section_en = response.data.desc_sub_section_en  
              this.section = response.data.section  
              this.url_1st_image = response.data.url_1st_image  
              this.url_2nd_image = response.data.url_2nd_image  
              this.url_3rd_image = response.data.url_3rd_image  
              this.url_4th_image = response.data.url_4th_image  
              this.url_5th_image = response.data.url_5th_image  
              this.type_1st_image = response.data.type_1st_image  
              this.type_2nd_image = response.data.type_2nd_image  
              this.type_3rd_image = response.data.type_3rd_image  
              this.type_4th_image = response.data.type_4th_image  
              this.type_5th_image = response.data.type_5th_image  
              this.text1_es = response.data.text1_es  
              this.text1_en = response.data.text1_en 
              this.text2_es = response.data.text2_es  
              this.text2_en = response.data.text2_en  
              this.text3_es = response.data.text3_es  
              this.text3_en = response.data.text3_en  
              this.orientation = response.data.orientation  
              this.url_es = response.data.url_es  
              this.url_en = response.data.url_en  
              this.order_sub_section = response.data.order_sub_section  
              this.id_position_menu = response.data.id_position_menu  
              this.url_video = response.data.url_video 
              this.type = response.data.type 

               //SEO
              this.page_title = this.nom_sub_sec_es;
              this.page_description = this.desc_sub_section_es;
              this.page_keywords = response.data.keywords;
              
             
          })
           .catch(error => {
            console.log("error");
      })
    },

    scroll_inicio(){
      window.scrollTo(0,0);
    },

    getPosition: function(marker) {
      return {
        lat: parseFloat(marker.lat),
        lng: parseFloat(marker.lng)
      }
    },

    toggleInfo: function(marker, key) {
      this.infoPosition = this.getPosition(marker)
      this.infoContent = marker.full_name
      if (this.infoCurrentKey == key) {
        this.infoOpened = !this.infoOpened
      } else {
        this.infoOpened = true
        this.infoCurrentKey = key
      }
    }
  },

  created() {
    this.scroll_inicio();
    this.obtener_sub_section_data();
    this.callDepartamentos();
  }
};
</script>